import { render } from "./Index_contact_en.vue?vue&type=template&id=e5009fd8&scoped=true"
import script from "./Index_contact_en.vue?vue&type=script&lang=js"
export * from "./Index_contact_en.vue?vue&type=script&lang=js"

import "./Index_contact_en.vue?vue&type=style&index=0&id=e5009fd8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e5009fd8"

export default script